import { ContractPropertyName } from '../../../constants';
import { Types } from '../../constants';
import { Helper } from '../Helper';
export class CompleteSendHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitSysCall(node, 'System.ExecutionEngine.GetScriptContainer');
        sb.emitSysCall(node, 'Neo.Transaction.GetInputs');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'DUP');
                sb.emitOp(node, 'ARRAYSIZE');
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'NUMEQUAL');
            },
            whenTrue: () => {
                sb.emitOp(node, 'DROP');
                sb.emitPushBoolean(node, false);
            },
            whenFalse: () => {
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'PICKITEM');
                sb.emitOp(node, 'DUP');
                sb.emitSysCall(node, 'Neo.Input.GetIndex');
                sb.emitHelper(node, options, sb.helpers.if({
                    condition: () => {
                        sb.emitPushInt(node, 0);
                        sb.emitOp(node, 'NUMEQUAL');
                    },
                    whenTrue: () => {
                        sb.emitSysCall(node, 'Neo.Input.GetHash');
                        sb.emitHelper(node, options, sb.helpers.createStructuredStorage({
                            prefix: ContractPropertyName.claimedTransactions,
                            type: Types.MapStorage,
                        }));
                        sb.emitOp(node, 'SWAP');
                        sb.emitHelper(node, options, sb.helpers.wrapBuffer);
                        sb.emitHelper(node, options, sb.helpers.getStructuredStorage({
                            type: Types.MapStorage,
                            keyType: undefined,
                            knownKeyType: Types.Buffer,
                        }));
                        sb.emitHelper(node, options, sb.helpers.if({
                            condition: () => {
                                sb.emitOp(node, 'DUP');
                                sb.emitHelper(node, options, sb.helpers.isUndefined);
                            },
                            whenTrue: () => {
                                sb.emitOp(node, 'DROP');
                                sb.emitPushBoolean(node, false);
                            },
                            whenFalse: () => {
                                sb.emitHelper(node, options, sb.helpers.unwrapBuffer);
                                sb.emitHelper(node, options, sb.helpers.isCaller);
                                sb.emitSysCall(node, 'System.ExecutionEngine.GetScriptContainer');
                                sb.emitSysCall(node, 'Neo.Transaction.GetReferences');
                                sb.emitHelper(node, options, sb.helpers.arrFilter({
                                    map: () => {
                                        sb.emitSysCall(node, 'Neo.Output.GetScriptHash');
                                        sb.emitSysCall(node, 'System.ExecutionEngine.GetExecutingScriptHash');
                                        sb.emitOp(node, 'EQUAL');
                                    },
                                }));
                                sb.emitOp(node, 'ARRAYSIZE');
                                sb.emitPushInt(node, 1);
                                sb.emitOp(node, 'NUMEQUAL');
                                sb.emitOp(node, 'BOOLAND');
                            },
                        }));
                    },
                    whenFalse: () => {
                        sb.emitOp(node, 'DROP');
                        sb.emitPushBoolean(node, false);
                    },
                }));
            },
        }));
    }
}

//# sourceMappingURL=CompleteSendHelper.js.map
